/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCVOpenIcon20Solid = forwardRef('ArrowCollapseCVOpenIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.944 2.877a2.75 2.75 0 0 0-3.889 0l-3.24 3.24a1.25 1.25 0 0 0 1.769 1.767l3.239-3.24a.25.25 0 0 1 .354 0l3.239 3.24a1.25 1.25 0 0 0 1.768-1.768l-3.24-3.24Z" }),
        React.createElement("path", { d: "M11.944 17.123a2.75 2.75 0 0 1-3.889 0l-3.24-3.24a1.25 1.25 0 0 1 1.769-1.767l3.239 3.24a.25.25 0 0 0 .354 0l3.239-3.24a1.25 1.25 0 0 1 1.768 1.768l-3.24 3.24Z" })));
});
